import { callApiToServer } from "../callApi";

export async function addCorporateUser(authtoken, userObject) {
  console.log('calling');
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    console.log('!!!!!!!userObject', userObject);
    let body = JSON.stringify(userObject);

    let endUrl = "v1/auth/admin/add-corporate-user";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
